;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('SageDotCom/Components/ScoreFixes/VimeoVideo',["score_bootstrap/Components/VimeoVideo", "vimeo_api"], factory) :
        typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("score_bootstrap/Components/VimeoVideo"), require("vimeo_api")) :
    console && console.error('VimeoVideo component cannot be loaded into global namespace');
}(this/* window */, function (vimeoComponent, vimeoApi) {

    function VimeoVideo() {
        // call the inherited const
        vimeoComponent.apply(this, arguments);
    }

    VimeoVideo.prototype = Object.create(vimeoComponent.prototype);

    VimeoVideo.init = function init(args) {
        if (vimeoApi && "error_sage_fallback" in vimeoApi) {
            console && console.info && console.info('VimeoVideo component could not load vimeo api');
            return null;
        }

        if (args.IsEditorEditing) return null;

        var video = new VimeoVideo(args.scope,
            args.StateChangeMessagesTransmitting || [],
            args.PlayActionMessages || [],
            args.PauseActionMessages || []);

        return video;
    };

    return VimeoVideo;
}));
